/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineReportService() {
        let reportService = {};
        reportService.getReportYearsAndMonths = function () {
            return axios.get("/api/ReportService/GetReportYearsAndMonths");
        };
        reportService.getDashboardSummary = function (request) {
            return axios.post("/api/ReportService/GetDashboardSummary", request);
        };
        reportService.downloadCustomerSignUpsReport = function (request) {
            return axios.post("/api/ReportService/DownloadCustomerSignUpsReport", request, { responseType: 'blob' }).then(
                response =>{
                    return response;
                }
            ).catch(error => {
                    console.log("error", error);
                    apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                    return error.response;
                });
        };
        reportService.downloadDetailedCustomerTransactionsReport = function (request) {
            return axios.post("/api/ReportService/DownloadDetailedCustomerTransactionsReport", request, { responseType: 'blob' }).then(
                response =>{
                    return response;
                }
            ).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        reportService.downloadCustomerPointBalancesReport = function (request) {
            return axios.post("/api/ReportService/DownloadCustomerPointBalancesReport", request, { responseType: 'blob' }).then(
                response =>{
                    return response;
                }
            ).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        reportService.downloadCustomerEarningAndRedeemingFrequencyReport = function (request) {
            return axios.post("/api/ReportService/DownloadCustomerEarningAndRedeemingFrequencyReport", request, { responseType: 'blob' }).then(
                response =>{
                    return response;
                }
            ).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        return reportService;
    }
    //define globally if it doesn't already exist
    if (typeof (reportService) === "undefined") {
        window.reportService = defineReportService();
    } else {
        console.log("reportService already defined.");
    }
})(window);